export default __webpack_public_path__ + "static/media/logo.9e5ddc28.png";